// extracted by mini-css-extract-plugin
export default {"header":"a9da5da56642","needHelpIcon":"cb6c3ba6a03b","needHelpText":"c793cd5a072b","supportTooltip":"b66a627c9c09"};